<template lang="pug">
  b-modal#checkMemberFreeSpin(
  ref="checkMemberFreeSpin"
  :title="$t('ui.combine.check_free_spin')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="accountId"
          required
          alphaNum
          type="text"
          :dirty="$v.accountId.$dirty"
          :error="$v.accountId.$error"
          v-model.trim.lazy="$v.accountId.$model"
          :disabled="loading"
          :maxLength="$v.accountId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.accountId" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.provider')").mb-0
        b-form-select(
          :dirty="$v.provider.$dirty"
          :error="$v.provider.$error"
          v-model.trim.lazy="$v.provider.$model"
          :disabled="loading"
          size="sm"
          @change="checkMemberFreeSpin($event)"
        )
          option(value="" disabled selected) {{ $t("message.select_option") }}
          option(value="EPW") EPICWIN
          option(value="MGH") MEGAH5
          option(value="GSC-PP-S") PRAGMATIC
      ValidateResult(:value="$v.provider" :name="$t('ui.provider')")
      template(v-if="['EPW','MGH'].includes(provider)")
        b-form-group(:label="$t('ui.result')" disabled).mb-3
          b-form-textarea.mb-2.h-auto(v-model="responseJson" rows="15")
          span.small.text-info.mt-1 {{ $t("message.check_freespin_result_message_0") }}
          br
          span.small.text-info {{ $t("message.check_freespin_result_message_1") }}
          br
          span.small.text-info {{ $t("message.check_freespin_result_message_2") }}
          br
          span.small.text-info {{ $t("message.check_freespin_result_message_3") }}
          br
          span.small.text-info {{ $t("message.check_freespin_result_message_400") }}
          br
          span.small.text-info {{ $t("message.check_freespin_result_message_500") }}
        b-form-group(:label="$t('ui.current_round')" v-if="freeRoundList.length != 0").mt-3
          .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th(width="3%")
                      span #
                    th(width="9%")
                      span(:title="$t('ui.round_id')") {{ $t("ui.round_id") }}
                    th(width="8%")
                      span
                tbody
                  tr(v-if="freeRoundList.length == 0")
                    td(colspan="3").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in freeRoundList")
                    td
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.FreeRoundId") {{ item.FreeRoundId }}
                    td.text-center
                      SubmitButton(
                        :loading="loading"
                        icon="fa fa-ban"
                        :text="$t('ui.cancel')"
                        type="button"
                        @click="cancelFreeRound(item)"
                        variant="warning"
                        size="sm"
                        )
      template(v-if="['GSC-PP-S'].includes(provider)")
        b-form-group(:label="$t('ui.result')" disabled).mb-3
          b-form-textarea.mb-2.h-auto(v-model="responseJson" rows="15")
        b-form-group(:label="$t('ui.current_round')" v-if="freeRoundList.length != 0").mt-3
          .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th(width="3%")
                      span #
                    th(width="9%")
                      span(:title="$t('ui.round_id')") {{ $t("ui.round_id") }}
                    th(width="8%")
                      span
                tbody
                  tr(v-if="freeRoundList.length == 0")
                    td(colspan="3").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in freeRoundList")
                    td
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.bonusCode") {{ item.bonusCode }}
                    td.text-center
                      SubmitButton(
                        :loading="loading"
                        icon="fa fa-ban"
                        :text="$t('ui.cancel')"
                        type="button"
                        @click="cancelFreeRound(item)"
                        variant="warning"
                        size="sm"
                        )
      //- div.row
      //-   div.col
      //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      accountId: "",
      responseJson: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      provider: "",
      roundList: [],
    };
  },
  computed: {
    freeRoundList() {
      if (['EPW','MGH'].includes(this.provider))
        return this.roundList.filter(d => { return d.Status == 0 || d.Status == 1 });
      else if (['GSC-PP-S'].includes(this.provider)) {
        var current = new Date();
        return this.roundList.filter(d => { return ((d.rounds > d.roundsPlayed) && (current < new Date(d.expirationDate))) });
      }
    },
  },
  validations: {
    accountId: {
      required,
      // minLength: minLength(6),
      maxLength: maxLength(20)
    },
    provider: {
      required
    }
  },
  methods: {
    checkMemberFreeSpin: function(code) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = "";

        if (this.provider == 'EPW')
          url = config.epicWinGetFreeRoundUrl();
        else if (this.provider == 'MGH')
          url = config.megah5GetFreeRoundUrl();
        else if (this.provider == 'GSC-PP-S')
          url = config.ppsGetFreeRoundUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          second_id: this.item.second_id
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? (response.data.status == "1" || response.data.status == "2") : (response.data.status == 1 || response.data.status == 2);

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  var obj = response.data.dt
                  this.responseJson = (obj != null ? JSON.stringify(obj, undefined, 4) : null);
                  this.roundList = response.data.dt
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    cancelFreeRound: function(item) {
      var round = null;
      if (['EPW','MGH'].includes(this.provider))
        round = item.FreeRoundId;
      else if (['GSC-PP-S'].includes(this.provider))
        round = item.bonusCode;

      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.cancel_free_round_confirm", { round: round }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmCancelFreeRound(item);
          } else {
            this.checkMemberFreeSpin();
          }
        });
    },
    confirmCancelFreeRound: function(item) {
      let url = "";
      if (this.provider == 'EPW')
        url = config.epicWinCancelFreeRoundUrl();
      else if (this.provider == 'MGH')
        url = config.megah5CancelFreeRoundUrl();
      else if (this.provider == 'GSC-PP-S')
        url = config.ppsCancelFreeRoundUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        second_id: this.item.second_id
        // free_round_id: item.FreeRoundId
      };

      if (['EPW','MGH'].includes(this.provider))
        json.free_round_id = item.FreeRoundId;
      else if (['GSC-PP-S'].includes(this.provider))
        json.free_round_id = item.bonusCode;

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.checkMemberFreeSpin();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.accountId = this.item.account_id;
      this.responseJson = "";
      this.provider = "";
      this.roundList = []
      //this.checkMemberFreeSpin();
    }
  }
};
</script>